import React from "react";
import styled from "styled-components";
import Spinner from "./Spinner";

const StyledLoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const LoadingOverlay = () => {
  return (
    <StyledLoadingOverlay>
      <Spinner />
    </StyledLoadingOverlay>
  );
};

export default LoadingOverlay;
